import { type Ref, unref, watchEffect, ref } from 'vue';
import { type MaybeRef } from '@vueuse/core';
import { type ParsedBreadcrumb } from '@shared/component/VBreadcrumb/types';
import { type Breadcrumb } from './types';
import { useBreadcrumbStore } from './breadcrumbStore';

export function useBreadcrumb<T>(
  breadcrumbs: MaybeRef<Breadcrumb<T>[]>,
  itemValueParams: Ref<T> = ref({}) as Ref<T>,
) {
  const breadcrumbStore = useBreadcrumbStore();

  const parseItem = ({ link, name }: Breadcrumb<T>): ParsedBreadcrumb => ({
    link: typeof link === 'function' ? link(itemValueParams.value) : link,
    name: typeof name === 'function' ? name(itemValueParams.value) : name,
  });

  const hasBreadcrumb = (b: Breadcrumb<T>) => !!b;

  const parseItems = (): ParsedBreadcrumb[] =>
    unref(breadcrumbs).filter(hasBreadcrumb).map(parseItem);

  watchEffect(() => (breadcrumbStore.breadcrumbs = parseItems()));

  return {
    breadcrumbStore,
  };
}
